import { render, staticRenderFns } from "./tongueRoundN.vue?vue&type=template&id=bf5beada&"
import script from "./tongueRoundN.vue?vue&type=script&lang=js&"
export * from "./tongueRoundN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports